import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import UserSearch from '@/shared/components/input/UserSearch';
import messages from '../messages';

class ChangePlannedRegistrationUserModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: null,
      showValidation: false,
    };
  }
  state = {};

  isFormInvalid = () => {
    const { userId } = this.state;
    if (!userId) return true;
    return false;
  };
  userChanged = user => {
    this.setState({ userId: user?.id });
  };
  onSave = () => {
    if (this.isFormInvalid()) return;
    const { onSave } = this.props;
    const { userId } = this.state;
    return onSave({ userId });
  };
  showValidation = () => this.setState({ showValidation: true });

  render() {
    const { show, onClose, intl } = this.props;
    const { userId, showValidation } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeUser)}
        show={show}
        onClose={onClose}
        disabled={showValidation && this.isFormInvalid()}
        onHoverSave={this.showValidation}
        onSave={this.onSave}
      >
        <div className="form-horizontal">
          <div className="form-group">
            <label className="col-sm-4 control-label" htmlFor="user">
              <FormattedMessage {...messages.User} />
            </label>
            <div className="col-sm-7">
              <UserSearch onChange={this.userChanged} value={userId} withSystemUser />
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}

ChangePlannedRegistrationUserModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,

  intl: intlShape.isRequired,
};
ChangePlannedRegistrationUserModal.defaultProps = {
  show: false,
};
export default ChangePlannedRegistrationUserModal;
